<template>
    <div>
        <v-row class="ml-1 mb-2">
            <v-col class="no-pd" cols="12">
                <h3 style="color: #545353">SCHEDULED TODAY</h3>
            </v-col>
        </v-row>
        <v-row
            align="center"
            class="no-pd"
            v-for="(row, index) in data_ScheduleCase"
            :key="index"
        >
            <v-expansion-panels>
                <v-expansion-panel>
                    <v-expansion-panel-header
                        dense
                        :color="status_color[row.status_color]"
                    >
                        <span class="fix-font-b">
                            {{ row.case_id + "-" + row.subcase }}
                            <span class="ml-5">{{ row.site_name }}</span>
                        </span>
                    </v-expansion-panel-header>

                    <v-expansion-panel-content>
                        <v-row>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-2 mt-4"
                                cols="8"
                            >
                                <v-chip small color="info" class="mr-1">
                                    {{ row.project_name }}</v-chip
                                >
                                <v-chip small>
                                    <v-icon small color="info" class="mr-1">
                                        mdi-timer
                                    </v-icon>
                                    {{ row.created_date }}</v-chip
                                >

                                <v-icon
                                    color="red"
                                    v-if="
                                        row.show_ismart == 'Y' &&
                                            row.skip_ismart == 'N'
                                    "
                                >
                                    mdi-information
                                </v-icon>
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-2 text-right mt-1"
                                cols="4"
                            >
                                <v-btn
                                    :color="status_color[row.status_color]"
                                    fab
                                    small
                                    dark
                                    @click="schedul(row)"
                                >
                                    <v-icon>mdi-plus</v-icon>
                                </v-btn>
                            </v-col>
                            <v-col
                                cols="12"
                                class="mar-t-10"
                                v-if="row.subcase_wonumber"
                            >
                            <v-icon color="primary" class="mr-1"
                                        >mdi-package-variant</v-icon
                                    >
                                <span class="primary--text font-b">
                                    {{ row.subcase_wonumber }}
                                </span>

                                <v-tooltip top class="ml-1">
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            x-small
                                            v-on="on"
                                            fab
                                            @click="doCopyLog(row.subcase_wonumber)"
                                        >
                                            <v-icon>mdi-content-copy</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Copy {{ row.subcase_wonumber }}</span>
                                </v-tooltip>
                            </v-col>
                            <v-col
                                :class="
                                    row.wonumber
                                        ? 'caption font-weight-bold pb-0 pt-1 color-font-c-2 mar-t-10'
                                        : 'caption font-weight-bold pb-0 pt-1 color-font-c-2'
                                "
                                v-if="row.case_title"
                                cols="12"
                            >
                                {{ row.case_title }}
                                <br v-if="row.subcase_title" />
                                <v-chip
                                    v-if="row.subcase_title"
                                    x-small
                                    color="purple lighten-4"
                                    >{{ row.subcase_title }}</v-chip
                                >
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                                v-if="row.site_name"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" small>mdi-home</v-icon
                                >{{ row.site_name }}
                            </v-col>

                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                                v-if="row.site_address"
                                cols="12"
                            >
                                <v-icon
                                    class="pr-1 pb-1"
                                    small
                                    style="color: #ef6c00"
                                    >mdi-home-circle</v-icon
                                >
                                <b style="color: #ef6c00; font-weight: bold">{{
                                    row.site_address
                                }}</b>
                            </v-col>

                            <v-col
                                cols="12"
                                class="mar-t-10"
                                v-if="row.case_refer"
                            >
                                <b>Case Refer :</b> {{ row.case_refer }}
                            </v-col>

                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                                v-if="row.customer_name"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" small
                                    >mdi-account-circle</v-icon
                                >{{ row.customer_name }}
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                                v-for="(phone, indexP) in row.customer_tel"
                                :key="indexP"
                                cols="6"
                            >
                                <v-icon style="color: #dbb20d">
                                    mdi-whatsapp
                                </v-icon>
                                <a
                                    style="color: #dbb20d; font-weight: bold"
                                    :href="`tel:${phone}`"
                                    class="ml-1"
                                    >{{ phone }}</a
                                >
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                                cols="12"
                                v-if="row.product_no || row.product_description"
                            >
                                <v-icon class="pr-1 pb-1" small
                                    >mdi-cellphone-link</v-icon
                                >
                                {{ row.product_no }}
                                <span v-if="row.product_description">
                                    - {{ row.product_description }}</span
                                >
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" small>mdi-tag</v-icon>
                                {{ row.product_serial }}
                            </v-col>
                            <v-col
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-2"
                                v-if="row.remark"
                                cols="12"
                            >
                                <v-icon class="pr-1 pb-1" small
                                    >mdi-chat-alert</v-icon
                                >{{ row.remark }}
                            </v-col>
                            <v-col
                                cols="12"
                                class="caption font-weight-bold pb-0 pt-1 color-font-c-1"
                            >
                                <div v-if="row.parts.length == 0">
                                    <p class="ma-0">
                                        <v-icon class="pr-1 pb-1"
                                            >mdi-pound</v-icon
                                        >Checking
                                    </p>
                                </div>
                                <div
                                    v-else
                                    v-for="(part, i) in row.parts"
                                    :key="i"
                                >
                                    <p
                                        class="ma-0"
                                        v-if="part.ponumber == null"
                                    >
                                        <v-icon
                                            class="pr-1 pb-1"
                                            small
                                            :style="
                                                part.status == 'Reserve'
                                                    ? 'color:#D500F9;'
                                                    : 'color:#0097A7;'
                                            "
                                            >mdi-pound</v-icon
                                        >
                                        <span
                                            :style="
                                                part.status == 'Reserve'
                                                    ? 'color:#D500F9; font-weight: bold;'
                                                    : 'color:#0097A7; font-weight: bold;'
                                            "
                                        >
                                            {{
                                                part.part_name +
                                                    " " +
                                                    part.part_description
                                            }}
                                        </span>
                                    </p>
                                    <p class="ma-0" v-else>
                                        <v-icon
                                            class="pr-1 pb-1"
                                            small
                                            :style="
                                                part.status == 'Reserve'
                                                    ? 'color:#D500F9;'
                                                    : 'color:#0097A7;'
                                            "
                                            >mdi-pound</v-icon
                                        >
                                        <span
                                            :style="
                                                part.status == 'Reserve'
                                                    ? 'color:#D500F9; font-weight: bold;'
                                                    : 'color:#0097A7; font-weight: bold;'
                                            "
                                        >
                                            {{
                                                part.ponumber +
                                                    " / " +
                                                    part.part_name +
                                                    " " +
                                                    part.part_description
                                            }}</span
                                        >
                                    </p>
                                </div>
                            </v-col>

                            <v-col cols="12" v-if="row.lognote.length > 0">
                                <v-textarea
                                    readonly
                                    outlined
                                    v-model="row.lognote"
                                    background-color="#e6f3ff"
                                    label="Log Note..."
                                    rows="6"
                                ></v-textarea>
                            </v-col>
                        </v-row>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-row>

        <!-- Modal -->
        <v-row justify="center">
            <v-form method="post" id="nativeForm" v-model="valid">
                <v-dialog v-model="dialog" persistent max-width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ show_case }}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12" sm="6">
                                        <v-select
                                            :items="
                                                team_name == 'ONSITE'
                                                    ? data_status
                                                    : data_status2
                                            "
                                            label="Status"
                                            item-text="name"
                                            item-value="id"
                                            v-model="form.status"
                                            :rules="statusR"
                                            @change="change_status()"
                                            required
                                        >
                                            <template #selection="{ item }">
                                                <v-chip
                                                    v-if="
                                                        item.id == 'Uncontrol'
                                                    "
                                                    color="red"
                                                    >{{ item.name }}</v-chip
                                                >
                                                <v-chip v-else>
                                                    {{ item.name }}
                                                </v-chip>
                                            </template>
                                        </v-select>
                                        <!-- <v-select
                                            v-model="value"
                                            :items="roles"
                                            :menu-props="{
                                                top: true,
                                                offsetY: true,
                                            }"
                                            small-chips
                                            label="Roles"
                                            multiple
                                            hint="Select the role"
                                            persistent-hint
                                        >
                                            <template #selection="{ item }">
                                                <v-chip color="blue">{{
                                                    item.name
                                                }}</v-chip>
                                            </template>
                                        </v-select> -->
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        v-if="form.status === 'transfercase'"
                                    >
                                        <v-select
                                            :items="data_emp"
                                            label="Zone"
                                            item-text="branch_name"
                                            item-value="engineer"
                                            v-model="zone"
                                            required
                                        ></v-select
                                    ></v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        v-if="form.status === 'transfercase'"
                                    >
                                        <v-select
                                            :items="zone"
                                            label="Engineer"
                                            item-text="emp_name_en"
                                            item-value="emp_id"
                                            v-model="form.engineer_id"
                                            required
                                        ></v-select>
                                    </v-col>
                                    <v-col
                                        cols="12"
                                        sm="6"
                                        v-if="chk_show === 2"
                                    >
                                        <v-select
                                            :items="data_scheduled"
                                            label="ช่วงเวลาที่นัดลูกค้า"
                                            item-text="schedule_range"
                                            item-value="schedule_id"
                                            required
                                            v-model="form.schedule_id"
                                        ></v-select>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        sm="6"
                                        v-if="chk_show === 3"
                                    >
                                        <v-dialog
                                            ref="dialog"
                                            v-model="modal"
                                            :return-value.sync="date"
                                            persistent
                                            width="290px"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-text-field
                                                    v-model="form.date"
                                                    label="วันที่นัดลูกค้า"
                                                    prepend-icon=""
                                                    readonly
                                                    v-on="on"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                :min="date_min"
                                                v-model="form.date"
                                                scrollable
                                            >
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="modal = false"
                                                    >Cancel</v-btn
                                                >
                                                <v-btn
                                                    text
                                                    color="primary"
                                                    @click="
                                                        $refs.dialog.save(
                                                            form.date
                                                        )
                                                    "
                                                    >OK</v-btn
                                                >
                                            </v-date-picker>
                                        </v-dialog>
                                    </v-col>

                                    <v-col
                                        cols="12"
                                        sm="6"
                                        v-if="chk_show === 1 || chk_show === 3"
                                    >
                                        <v-textarea
                                            outlined
                                            label="Remark"
                                            v-model="form.remark"
                                            :rules="RemarkR"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                small
                                color="blue darken-1"
                                text
                                @click="close()"
                                >Close</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                rounded
                                small
                                color="success darken-1"
                                :disabled="!valid"
                                @click="func_eeg_api()"
                            >
                                <!-- @click="save_schedul()" -->
                                <!-- @click="func_eeg_api()" -->

                                <v-icon small class="mr-1">
                                    mdi-content-save
                                </v-icon>
                                Save
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-form>
        </v-row>
        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <template>
            <v-row justify="center">
                <v-dialog v-model="dialog_same_place" width="600px">
                    <v-card>
                        <v-card-title>
                            <span class="headline"
                                >Site นี้มีเคสที่เป็นสถานที่เดียวกัน อัพเดท
                                schedule เหมือนกันเลยหรือไม่ ?</span
                            >
                        </v-card-title>
                        <v-card-text>
                            <v-row
                                v-for="(r, i) in data_same_place.case_id"
                                :key="i"
                            >
                                <v-col cols="12">
                                    <v-chip small>{{ r }}</v-chip>
                                </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                text
                                rounded
                                small
                                @click="dialog_same_place = false"
                                >Close</v-btn
                            >
                            <v-spacer></v-spacer>
                            <v-btn
                                color="success"
                                small
                                rounded
                                @click="func_eeg_api_same_place()"
                            >
                                <!-- @click="save_same_place()" -->
                                <v-icon small class="mr-1">
                                    mdi-content-save
                                </v-icon>
                                Save Same place
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-row>
        </template>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
let url_eeg = "https://dev.itservices.api.hp.com/"
export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        // this.tk_eeg = {
        //     headers: {
        //         "Access-Control-Allow-Origin": "*",
        //         Authorization:
        //             "WWVsazBueXFEb3VHQThuZHRYWjNIRUpYekpIWWx0NTU6ZnpCYkp3UmozTEZSWXFVaG5OOVRRQXltelVkTG1YbnY",
        //         // Authorization:
        //         //     "Basic WWVsazBueXFEb3VHQThuZHRYWjNIRUpYekpIWWx0NTU6ZnpCYkp3UmozTEZSWXFVaG5OOVRRQXltelVkTG1YbnY=",
        //     },
        // }
    },
    mounted() {
        let date = new Date()
        date.setDate(date.getDate() + 1)
        // console.log(new Date().toISOString().substr(0, 10))
        this.date_min = date.toISOString().substr(0, 10)
        // console.log(this.data_ScheduleCase, "-xx")
        this.get_emp_id()
    },
    props: ["data_ScheduleCase"],
    computed: {
        ...mapState(["isLoading"]),
        ...mapState(["snackbar"]),
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        ...mapMutations(["mutatesnackbar"]),
        schedul(data) {
            console.log(data, "--x")
            this.data_same_place = []
            this.data_chenge = data
            this.dialog = true
            this.show_case = data.case_id + "-" + data.subcase

            this.form.maincase_id = data.maincase_id
            this.form.subcase_id = data.subcase_id
            this.form.project_name = data.project_name

            // this.data_same_place.subcase_id = data.data_same_place
            // this.data_same_place.subcase_id = data.subcase_id
        },
        close() {
            if (
                this.form.status != "Scheduled" ||
                localStorage.team_name == "ODM"
            ) {
                this.form.status = null
                this.form.engineer_id = null
                this.chk_show = 0
                this.form.remark = ""
                this.form.schedule_id = ""
            }

            this.form.maincase_id = 0
            this.dialog = false
            this.get_data()
        },
        async change_status() {
            if (this.form.status === "Scheduled") {
                let { data } = await axios.get(url + "schedule-time")
                this.data_scheduled = data
                this.chk_show = 2
            } else if (this.form.status === "Customer Reschedule") {
                this.chk_show = 3
            } else {
                this.chk_show = 1
            }

            if (this.form.status === "transfercase") {
                await axios
                    .get(url + "engineer/get-engineer-zone", this.tk)
                    .then((response) => {
                        this.data_emp = response.data
                    })
            }
        },
        async get_data() {
            this.$emit("select_menu")
        },
        async get_emp_id() {
            await axios.get(url + "members", this.tk).then((response) => {
                this.hp_learnerid = response.data.hp_learnerid
            })
        },
        cal_date_eeg(st, idx) {
            let date = new Date()
            let year = date.toLocaleString("default", { year: "numeric" })
            let month = date.toLocaleString("default", { month: "2-digit" })
            let day = date.toLocaleString("default", { day: "2-digit" })
            if (st == 1) {
                var h = date.getHours()
                var m = date.getMinutes()
                var s = date.getSeconds()
                let formattedDate =
                    year +
                    "-" +
                    month +
                    "-" +
                    day +
                    "T" +
                    h +
                    ":" +
                    m +
                    ":" +
                    s +
                    "Z"

                let myArray = formattedDate.split(" ")
                if (myArray.length == 1) {
                    let resX = formattedDate
                    return resX
                } else {
                    let arr1 = myArray[1].split("-")
                    let resX = `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`
                    return resX
                }
            } else if (st == 2) {
                let resX = year + "-" + month + "-" + day

                let myArray = resX.split(" ")
                let arr1 =
                    myArray.length == 1
                        ? myArray[0].split("-")
                        : myArray[1].split("-")
                let formattedDate =
                    myArray.length == 1
                        ? myArray[0]
                        : `${arr1[0] - 543}-${arr1[1]}-${arr1[2]}`

                if (idx == 1) {
                    return [
                        formattedDate + "T06:00:00",
                        formattedDate + "T08:00:00",
                    ]
                } else if (idx == 2) {
                    return [
                        formattedDate + "T08:00:00",
                        formattedDate + "T09:00:00",
                    ]
                } else if (idx == 3) {
                    return [
                        formattedDate + "T09:00:00",
                        formattedDate + "T10:00:00",
                    ]
                } else if (idx == 4) {
                    return [
                        formattedDate + "T10:00:00",
                        formattedDate + "T11:00:00",
                    ]
                } else if (idx == 5) {
                    return [
                        formattedDate + "T11:00:00",
                        formattedDate + "T12:00:00",
                    ]
                } else if (idx == 6) {
                    return [
                        formattedDate + "T12:00:00",
                        formattedDate + "T13:00:00",
                    ]
                } else if (idx == 7) {
                    return [
                        formattedDate + "T13:00:00",
                        formattedDate + "T14:00:00",
                    ]
                } else if (idx == 8) {
                    return [
                        formattedDate + "T14:00:00",
                        formattedDate + "T15:00:00",
                    ]
                } else if (idx == 9) {
                    return [
                        formattedDate + "T15:00:00",
                        formattedDate + "T16:00:00",
                    ]
                } else if (idx == 10) {
                    return [
                        formattedDate + "T16:00:00",
                        formattedDate + "T17:00:00",
                    ]
                } else if (idx == 11) {
                    return [
                        formattedDate + "T17:00:00",
                        formattedDate + "T18:00:00",
                    ]
                } else if (idx == 12) {
                    return [
                        formattedDate + "T18:00:00",
                        formattedDate + "T19:00:00",
                    ]
                } else if (idx == 13) {
                    return [
                        formattedDate + "T19:00:00",
                        formattedDate + "T23:59:00",
                    ]
                } else if (idx == 98) {
                    return [
                        formattedDate + "T13:00:00",
                        formattedDate + "T16:00:00",
                    ]
                } else if (idx == 99) {
                    return [
                        formattedDate + "16:00:00",
                        formattedDate + "T17:00:00",
                    ]
                }
            }
        },
        func_eeg_api() {
            if (
                this.data_chenge.show_ismart == "Y" &&
                this.data_chenge.skip_ismart == "N" &&
                this.data_chenge.project_name == "CDAX"
            ) {
                let datax
                if (this.form.status == "Scheduled") {
                    let date_dt = this.cal_date_eeg(2, this.form.schedule_id)

                    let Confirm_DT = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",
                            CaseID: this.data_chenge.case_id,
                            WorkOrder: [
                                {
                                    WorkOrderID: this.data_chenge.wonumber,
                                    PartnerName: "APJ_Acacia_P",
                                    PartnerStatus: "Partner Confirm D/T",
                                    PartnerStatusDateTime: this.cal_date_eeg(
                                        1,
                                        ""
                                    ),
                                    BookingDetails: {
                                        StartTime: date_dt[0],
                                        EndTime: date_dt[1],
                                    },
                                },
                            ],
                            Notes: {
                                NotesDescription: `$#Confirm D/T#$$# ${localStorage.fullname} ${this.hp_learnerid}\\nBooking Start Time:${date_dt[0]}\\nBooking End Time:${date_dt[1]} With customer ${this.data_chenge.customer_name} Tel ${this.data_chenge.customer_tel[0]}#$`,
                                ExternallyVisible: "No ",
                            },
                        },
                    }

                    datax = {
                        Confirm_DT: Confirm_DT,
                    }
                } else if (this.form.status == "Customer Reschedule") {
                    // เหลือที่ว่า StartTime  EndTime มาจากไหน
                    let date_dt2 = this.cal_date_eeg(2, 98)

                    let Partner_Cust_Delay = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",
                            WorkOrder: {
                                WorkOrderID: this.data_chenge.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Partner Cust Delay",
                                PartnerStatusDateTime: this.cal_date_eeg(1, ""),
                                RequestedDateTime: `${this.form.date}T17:30:00Z`, //this.cal_date_eeg(1, ""),
                                BookingDetails: {
                                    StartTime: `${this.form.date}T08:30:00Z`,
                                    EndTime: `${this.form.date}T17:30:00Z`,
                                },
                            },
                            Notes: {
                                NotesDescription: `$#Customer Delay#$$#${this.form.remark}#$`,
                                ExternallyVisible: "Yes",
                            },
                        },
                    }

                    datax = {
                        // Partner_Accept: Partner_Accept,
                        Partner_Cust_Delay: Partner_Cust_Delay,
                    }
                } else if (this.form.status == "Customer Cancel") {
                    let Cancelx = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",

                            WorkOrder: {
                                WorkOrderID: this.data_chenge.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Request to Cancel",
                                PartnerStatusDateTime: this.cal_date_eeg(1, ""),
                            },
                            Notes: {
                                NotesDescription: `#Request to Cancel#$$#${this.form.remark}#$`,
                                ExternallyVisible: "Yes",
                            },
                        },
                    }

                    datax = {
                        Request_Cancel: Cancelx,
                    }
                    // console.log(datax, "--datax")
                }
                this.form.project_name = this.data_chenge.project_name
                this.form.eeg = datax
            }
            // start sms
            if (
                this.data_chenge.sms_status == "Y" &&
                (this.form.status == "Customer Reschedule" ||
                    this.form.status == "Customer Cancel" ||
                    this.form.status == "Scheduled")
            ) {
                let str
                let dd = this.form.date.split("-")
                let date_sms = `${dd[2]}/${dd[1]}/${dd[0]}`
                if (this.form.status == "Scheduled") {
                    if (this.data_chenge.sms_language == "th") {
                        str = `งานซ่อมหมายเลข ${this.data_chenge.case_id} พร้อมให้บริการแล้ว คุณ ${this.data_chenge.engineer_name_th} จะเป็นผู้ให้บริการคุณในวันนี้  สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.data_chenge.sms_language == "en") {
                        str = `Case no: ${this.data_chenge.case_id} is now ready for service. HP Technician ${this.data_chenge.engineer_name_en} will be assisting you today.  For more information, please call 020781589.`
                    }
                } else if (this.form.status == "Customer Reschedule") {
                    if (this.data_chenge.sms_language == "th") {
                        str = `นัดหมายใหม่สำหรับงานซ่อมหมายเลข ${this.data_chenge.case_id} คือวันที่ ${date_sms} กรุณารอรับการติดต่อนัดหมายจากช่างของเราอีกครั้ง สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.data_chenge.sms_language == "en") {
                        str = `The new appointment for Case no: ${this.data_chenge.case_id} is scheduled for ${date_sms}. Please expect a follow-up call from our technician. For inquiries, call 020781589.`
                    }
                } else if (this.form.status == "Customer Cancel") {
                    if (this.data_chenge.sms_language == "th") {
                        str = `งานซ่อมหมายเลข ${this.data_chenge.case_id} ได้รับการยกเลิกแล้ว สอบถามข้อมูลเพิ่มเติมได้ที่ 020781589`
                    } else if (this.data_chenge.sms_language == "en") {
                        str = `Case no: ${this.data_chenge.case_id} has been cancelled. For more information, please call 020781589.`
                    }
                }
                let str_th = str
                str = str
                    .split("")
                    .map((char) => addZeros(char.charCodeAt(0).toString(16)))
                    .join("")
                // console.log(str)
                function addZeros(str) {
                    return ("0000" + str).slice(-4)
                }

                this.form.str = str
                this.form.str_th = str_th
                this.form.customer_tel = this.data_chenge.customer_tel[0]
                this.form.sms_language = this.data_chenge.sms_language
                this.form.sms_status = this.data_chenge.sms_status
            }
            // end sms

            console.log(this.data_chenge, "-data_chenge")
            console.log(this.form, "-form save")
            this.save_schedul()
        },
        async save_schedul() {
            this.dialog_loading = true
            await axios
                .post(url + "engineer/save-scheduled", this.form, this.tk)
                .then((response) => {
                    console.log(response, "-save_schedul")
                    this.dialog_loading = false
                    if (response.data.message === "update - complete") {
                        this.mutatesnackbar()
                        this.close()
                        this.get_data()
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                    } else if (response.data.message === "same place") {
                        this.close()
                        this.data_same_place = response.data
                        this.dialog_same_place = true
                    } else {
                        this.$swal("Scheduled wrong! Please try again.", {
                            icon: "warning",
                            button: false,
                            timer: 2000,
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        func_eeg_api_same_place() {
            this.data_ScheduleCase.map((r, i) => {
                if (this.data_same_place.case_id.includes(r.case_id) == true) {
                    let Partner_Accept = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",
                            WorkOrder: {
                                WorkOrderID: r.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Partner Accept",
                                PartnerStatusDateTime: this.cal_date_eeg(1, ""),
                            },
                            Notes: {
                                NotesDescription: "$#Accept#$",
                                ExternallyVisible: "Yes",
                            },
                        },
                    }

                    let date_dt = this.cal_date_eeg(
                        2,
                        this.data_same_place.schedule_id
                    )
                    let Confirm_DT = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",
                            CaseID: r.case_id,
                            WorkOrder: [
                                {
                                    WorkOrderID: r.wonumber,
                                    PartnerName: "APJ_Acacia_P",
                                    PartnerStatus: "Partner Confirm D/T",
                                    PartnerStatusDateTime: this.cal_date_eeg(
                                        1,
                                        ""
                                    ),
                                    BookingDetails: {
                                        StartTime: date_dt[0],
                                        EndTime: date_dt[1],
                                    },
                                },
                            ],
                            Notes: {
                                NotesDescription: `$#Confirm D/T#$$# ${localStorage.fullname} ${this.hp_learnerid}\\nBooking Start Time:${date_dt[0]}\\nBooking End Time:${date_dt[1]}#$`,
                                ExternallyVisible: "No ",
                            },
                        },
                    }
                    let Traveling = {
                        CaseExchange: {
                            EventType: "PartnerUpdates",
                            EventSubType: "Updates",
                            Originator: "EEG_qASi4aFrltEdrAvEJI7raTLrLswa",
                            IncomingChannel: "EEG",
                            WorkOrder: {
                                WorkOrderID: r.wonumber,
                                PartnerName: "APJ_Acacia_P",
                                PartnerStatus: "Partner Traveling",
                                PartnerStatusDateTime: this.cal_date_eeg(1, ""),
                                BookingDetails: {
                                    StartTime: date_dt[0],
                                    EndTime: date_dt[1],
                                },
                            },
                            Notes: {
                                NotesDescription: "$#CE Traveling#$",
                                ExternallyVisible: "Yes",
                            },
                        },
                    }
                    this.arr.push({
                        Partner_Accept: Partner_Accept,
                        Confirm_DT: Confirm_DT,
                        Traveling: Traveling,
                    })
                }
            })
            this.save_same_place()
        },
        async save_same_place() {
            this.data_same_place.project_name = this.data_chenge.project_name
            this.data_same_place.eeg = this.arr
            console.log(this.data_same_place, "-data_same_place")

            this.mutateIsLoading()
            await axios
                .post(
                    url + "engineer/save-scheduled-same-place",
                    this.data_same_place,
                    this.tk
                )
                .then((response) => {
                    if (response.data.message === "update - complete") {
                        this.mutateIsLoading()
                        this.mutatesnackbar()
                        this.dialog_same_place = false
                        this.get_data()
                        if (this.snackbar === true) {
                            setTimeout(() => {
                                this.mutatesnackbar()
                            }, 3000)
                        }
                    } else {
                        this.$swal("Scheduled wrong! Please try again.", {
                            icon: "warning",
                            button: false,
                            timer: 2000,
                        })
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        doCopyLog: function(textId) {
            this.text_copy = textId
            navigator.clipboard.writeText(this.text_copy)
            setTimeout(() => {
                this.showTooltip = !this.showTooltip
            }, 500)
            setTimeout(() => {
                this.showTooltip = false
            }, 2000)
        },
    },
    data() {
        return {
            fullname: localStorage.fullname,
            arr: [],
            hp_learnerid: null,
            data_chenge: [],
            dialog_loading: false,
            status_color: ["indigo lighten-3", "success", "amber"],
            dialog: false,
            data_scheduled: [],
            data_same_place: [],
            data_emp: [],
            data_status: [
                {
                    id: "Scheduled",
                    name: "นัดลูกค้าวันนี้",
                },
                {
                    id: "transfercase",
                    name: "โอนงานให้คนอื่น",
                },
                {
                    id: "Customer Reschedule",
                    name: "ลูกค้าขอเลื่อน",
                },
                {
                    id: "Customer Cancel",
                    name: "ลูกค้าขอยกเลิก",
                },
                // {
                //     id: "Clear by phone",
                //     name: "clear by phone",
                // },
                // {
                //     id: "Uncontrol",
                //     name: "ลูกค้าไม่สะดวกนัด / ไม่สามารถเข้าไซท์ได้",
                // },
                // {
                //     id: "xxx",
                //     name: "ดึงเคสกลับโซน",
                // },
            ],
            data_status2: [
                {
                    id: "Scheduled",
                    name: "นัดลูกค้าวันนี้",
                },
                {
                    id: "transfercase",
                    name: "โอนงานให้คนอื่น",
                },
                {
                    id: "Customer Reschedule",
                    name: "ลูกค้าขอเลื่อน",
                },
                {
                    id: "Customer Cancel",
                    name: "ลูกค้าขอยกเลิก",
                },
                // {
                //     id: "Clear by phone",
                //     name: "clear by phone",
                // },
            ],
            zone: [],
            valid: false,
            RemarkR: [(v) => !!v || "Remark is required"],
            statusR: [(v) => !!v || "Status is required"],
            form: {
                maincase_id: 0,
                subcase_id: 0,
                date: new Date().toISOString().substr(0, 10),
                eeg: {},
            },
            show_case: "",
            text: "Success, Your work has been saved",
            chk_show: 0,
            tk: "",
            tk_eeg: "",
            date_min: "",
            dialog_same_place: false,
            team_name: localStorage.team_name,
            modal: false,
            date: false,
        }
    },
}
</script>

<style scoped>
.fix-font-b {
    font-size: 16px;
    /* color: #0277bd; */
    color: #fff;
    font-weight: bold;
}
.color-font-c-1 {
    color: rgb(78, 113, 153) !important;
}

.color-font-c-2 {
    color: rgb(26, 57, 126) !important;
}
</style>
